import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React, { useEffect } from "react";
import { Controller, useForm, useFormState } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";

const QCParameterSelection = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const location = useLocation();
    const qcSampleData = location.state?.data;
    const itemIdRaw = qcSampleData?.item?.id;
    const itemId =
        typeof itemIdRaw === "object" && itemIdRaw !== null
            ? itemIdRaw?.id
            : itemIdRaw;

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm();

    const { isValid } = useFormState({
        control,
    });
    const { useFetch: useFetchParameters } = useAPIQuery({
        key: "item-parameter-association",
        endpoint: "/api/parameter-association/",
    });
    const {
        data: parameters,
        isLoading: parametersLoading,
        isError: parametersLoadingError,
    } = useFetchParameters({
        params: {
            q: itemId,
            c: "item_id",
            entries: 500,
        },
        enabled: !!itemId,
    });

    const toUniqueParameterOptions = (rows = []) => {
        const seen = new Set();
        const unique = [];
        for (const p of rows) {
            const pid = p?.parameter?.id;
            if (pid == null || seen.has(pid)) continue;
            seen.add(pid);
            unique.push({
                value: pid,
                label: p?.parameter?.parameter_name,
                parameter: p?.parameter,
            });
        }
        return unique;
    };

    const onSubmit = (data) => {
        navigate("/qc", {
            state: {
                data: {
                    ...qcSampleData,
                    parameters: toUniqueParameterOptions(data?.parameters || []),
                },
            },
        });
    };

    console.log(qcSampleData);

    useEffect(() => {
        if (!privileges.includes("select-qc-parameters") && parameters) {
            const uniqueParams = toUniqueParameterOptions(
                parameters?.results?.data || []
            );
            navigate("/qc", {
                state: {
                    data: {
                        ...qcSampleData,
                        parameters: uniqueParams,
                    },
                },
                replace: true,
            });
        }
    }, [parameters]);

    if (parametersLoading) return <>Loading...</>;

    if (parametersLoadingError) return <>Error</>;

    if (!privileges.includes("select-qc-parameters") && parameters)
        return <>Redirecting...</>;

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">Parameter Selection</h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select Parameters
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={toUniqueParameterOptions(
                                                    parameters?.results?.data ||
                                                        []
                                                )}
                                                isLoading={parametersLoading}
                                                isClearable={true}
                                                isMulti
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="parameters"
                                        control={control}
                                    />
                                    {errors.item && (
                                        <span className="fs-8 text-danger">
                                            Item is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {/* {isPending ? (
                      <button
                        type="button"
                        id="button-typemaster-loading"
                        className="btn btn-md text-dark"
                        disabled
                      >
                        Loading...
                      </button>
                    ) : ( */}
                                        <button
                                            type="submit"
                                            className="btn btn-md btn-primary"
                                            id="submit-button-create-typemaster"
                                            disabled={!isValid}
                                        >
                                            Submit
                                        </button>
                                        {/* )} */}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QCParameterSelection;
